import { OctagonX } from 'lucide-react'
import { type FC } from 'react'

import { getLocaleDateString } from 'utils'
import { type BrokersEscalationReason, type BrokersExclusionReason, type BrokersTask } from 'utils/web_api.schemas'

import { TaskReasonBadges } from './badges/TaskReasonBadges'

type TaskDetailsSectionProps = {
  task: BrokersTask
  showBlockedInfo?: boolean
}

const TaskDetailsSection: FC<TaskDetailsSectionProps> = ({ task, showBlockedInfo = true }) => {
  return (
    <>
      {/* Member Name */}
      {task.member_name && (
        <div className='text-sm'>
          <label className='block font-medium text-gray-700 mb-1'>
            Member
          </label>
          <p className='text-gray-900'>
            {task.member_name}
          </p>
        </div>
      )}

      {/* Task Details */}
      <div className='grid grid-cols-2 gap-4 text-sm'>
        <div>
          <label className='block font-medium text-gray-700 mb-1'>
            Created
          </label>
          <p className='text-gray-900'>
            {getLocaleDateString(new Date(task.created_at))}
          </p>
        </div>
        <div>
          <label className='block font-medium text-gray-700 mb-1'>
            Updated
          </label>
          <p className='text-gray-900'>
            {getLocaleDateString(new Date(task.updated_at))}
          </p>
        </div>
      </div>

      {/* Task Message */}
      {task.message && (
        <div>
          <label className='block font-medium text-gray-700 mb-1 text-sm'>
            Message
          </label>
          <p className='text-gray-900 text-sm bg-gray-50 p-2 rounded border'>
            {task.message}
          </p>
        </div>
      )}

      {/* Task Exclusion/Escalation Reasons */}
      <TaskReasonBadges
        exclusionReasons={task.task_metadata?.exclusion_reasons as BrokersExclusionReason[] | undefined}
        escalationReasons={task.task_metadata?.escalation_reasons as BrokersEscalationReason[] | undefined}
      />

      {/* Task Blocking Info */}
      {showBlockedInfo && !task.can_execute && task.status === 'pending' && (
        <div className='text-sm text-amber-700 bg-amber-100 rounded p-2 flex items-center gap-2'>
          <span className='font-medium flex items-center gap-2'>
            <OctagonX size={16} />
            Blocked:
          </span>
          <span className='text-gray-600'>
            Waiting for dependencies to complete
          </span>
        </div>
      )}
    </>
  )
}

export default TaskDetailsSection
